import StatTiles from './StatTiles.component';

export default StatTiles;